import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "className", "customTag"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as n } from "react/jsx-runtime";
import { concatClassNames as r } from "@sys42/utils";
import '../../assets/index8.css';
var i = "_overline_ztpvq_1",
  l = {
    overline: i
  };
function v(_ref) {
  var o = _ref.children,
    e = _ref.className,
    s = _ref.customTag,
    t = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */n(s || "div", _objectSpread(_objectSpread({
    className: r(e, l.overline)
  }, t), {}, {
    children: o
  }));
}
export { v as Overline };